






































import { Component, Vue } from "vue-property-decorator";
import Header from "@/components/Header.vue";
import Menu from "@/components/Menu.vue";
import DefDef from "@/views/Art/ArtPerfDef/DefDef.vue";
import DefOrigin from "@/views/Art/ArtPerfDef/DefOrigin.vue";
import DefEvolution from "@/views/Art/ArtPerfDef/DefEvolution.vue";
import NextPrevBtn from "@/components/NextPrevBtn.vue";
import Footer from "@/components/Footer.vue";
@Component({
  components: {
    Header,
    Menu,
    DefDef,
    DefOrigin,
    DefEvolution,
    NextPrevBtn,
    Footer,
  },
})
export default class ArtPerfDef extends Vue {
  protected nxtprevArtPerfDef = {
    BoolPrev: false,
    BoolNext: true,
    PrevImage: " ",
    NextImage: "/thumbnail7.png",
    PrevLink: " ",
    NextLink: "/PerformanceArtistique/Origines",
  };
}
